import { map } from "rxjs";
import { Entitlement } from "../../model";
import apiService from "../ApiService";

const getEntitlement = (uuid: string) => {
  return apiService
    .get<{ entitlement: Entitlement }>({
      path: `public/entitlements/${uuid}`,
      crm: true,
    })
    .pipe(map((e) => e.entitlement));
};
export { getEntitlement };
